export default{
  dataTables: (state) => state.dataTables,
  dataTable: (state) => state.dataTable,
  dataPaginations: (state) => state.dataPaginations,
  tableQueries: (state) => state.tableQueries
}



// WEBPACK FOOTER //
// ./src/components/app/gsTable/store/getters.js